/**
 * @author Muhammad Omran
 * @copyright Copyright 2020 by Radivision Inc., CA, USA. All Rights Reserved.
 * @Date: 2019-12-24
 * @description Implementation of the GraphQL mutation to create a user request.
 * @filename create-user-request.ts
 */
import { graphql, GraphQLTaggedNode } from "react-relay";

/**
 * The GraphQL mutation to create the user request.
 *
 * @type {GraphQLTaggedNode}
 */
export const CREATE_CLAIM_REQUEST_GRAPHQL_MUTATION: GraphQLTaggedNode = graphql`
  mutation createClaimRequestMutation($input: CreateClaimRequestInput!) {
    createClaimRequest(input: $input) {
      errors {
        id
        location
      }
      hasErrors
      userRequest {
        ... on ClaimRequest {
          id
          description
          expired
          personEmail
          kind
          revision
        }
        ... on UGCRequest {
          id
          description
          revision
        }
      }
    }
  }
`;
